export default __webpack_public_path__ + "assets/calendarIcon.a98167.svg";